export default __webpack_public_path__ + "static/media/servicetype_molding.abd1584e.png";